import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 text-navy-300 py-8 md:py-12 px-4 border-t border-navy-800" data-id="element-78">
      <div className="max-w-5xl mx-auto text-center" data-id="element-79">
        <h3 className="font-display text-3xl text-white mb-2 tracking-wide" data-id="element-80">
          💪 MEGAPACK FUERZA MAYOR™
        </h3>
        <p className="max-w-2xl mx-auto mb-8 text-navy-400" data-id="element-81">
          El sistema de clases N°1 para profes y kinesiólogos que trabajan con
          adultos mayores en Argentina. Porque entrenar adultos mayores no
          debería costarte todas las noches de la semana.
        </p>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm font-medium" data-id="element-82">
          <a href="mailto:contacto@recursosfitness.shop" className="hover:text-white transition-colors" data-id="element-83">
            contacto@recursosfitness.shop
          </a>
          <span className="hidden sm:inline" data-id="element-84">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-85">
            @recursosfitness.ar
          </a>
          <span className="hidden sm:inline" data-id="element-86">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-87">
            recursosfitness.shop
          </a>
        </div>

        <p className="text-xs text-navy-500" data-id="element-88">
          © RecursosFitness.shop™ 2026 — Todos los derechos reservados.
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}